import React, { useContext, useEffect, useRef, useState } from "react"
import PageContext from "../page-context"
import { replacePlaceholder } from "../utilities"
import DfbIcon from "../ui-kit/dfb_icon"

/**
 * Render an enhanced filter component
 * @param uid A unique id for the use of the component to be able to generate unique id fields
 * @param {Object} availableFilterOptions
 * @param {Function} setSelectedFilterOptions
 * @param {Integer} totalCount
 * @param {String} add_class
 * @return {JSX.Element|null}
 */
const CFilterEnhanced = ({
  uid,
  availableFilterOptions, // liefert alle options mit den ausgewählten mit selected=true
  setSelectedFilterOptions, // setzt die aktuell gewählten filter
  totalCount, // liefert die element-anzahl der (gefilterten) collection
  add_class,
}) => {
  const rootRef = useRef(null)

  const [showFormatFilter, setShowFormatFilter] = useState(false)
  const [showCategoryFilter, setShowCategoryFilter] = useState(false)
  const { translations } = useContext(PageContext)
  const text = translations.c_filter_enhanced
  const textContext = { count: totalCount }

  const handleFilter = () => {
    const activeFormats = rootRef.current.querySelectorAll(
      "input:checked[name=format]"
    )
    const formats = Array.from(activeFormats).map((input) => input.value)

    const activeCategories = rootRef.current.querySelectorAll(
      "input:checked[name=category]"
    )
    const root_categories = Array.from(activeCategories).map(
      (input) => input.value
    )

    setSelectedFilterOptions({
      formats: formats,
      root_categories: root_categories,
    })
  }

  useEffect(() => {
    if (
      availableFilterOptions &&
      availableFilterOptions.formats &&
      availableFilterOptions.formats.length > 0
    ) {
      setShowFormatFilter(true)
    }
    if (
      availableFilterOptions &&
      availableFilterOptions.root_categories &&
      availableFilterOptions.root_categories.length > 0
    ) {
      setShowCategoryFilter(true)
    }
  }, [availableFilterOptions])

  if (!(showFormatFilter || showCategoryFilter)) {
    return null
  }

  return (
    <div
      className={`c-FilterEnhanced ${add_class ? add_class : ""}`}
      ref={rootRef}
    >
      <input
        className="c-FilterEnhanced-toggle-input"
        type="checkbox"
        id="toggle"
      />
      <label className="c-FilterEnhanced-toggle-label" htmlFor="toggle">
        <DfbIcon
          icon_type="add"
          add_class="c-FilterEnhanced-toggle-icon c-FilterEnhanced-toggle-icon--add"
        />
        <DfbIcon
          icon_type="check"
          add_class="c-FilterEnhanced-toggle-icon c-FilterEnhanced-toggle-icon--check"
        />
        {text.filter}
      </label>
      <label className="c-FilterEnhanced-results-info">
        {replacePlaceholder(text.results, textContext)}
      </label>
      <div className="c-FilterEnhanced-layer">
        <div className="c-FilterEnhanced-controls">
          <div className="c-FilterEnhanced-header">
            <div className="c-FilterEnhanced-title">{text.filter}</div>
            <div className="c-FilterEnhanced-reset-button">
              <button
                className="dfb-Anchor"
                type="button"
                onClick={handleFilter}
              >
                <span className="dfb-Anchor-label">{text.reset}</span>
              </button>
            </div>
          </div>
          <div className="c-FilterEnhanced-body">
            {showFormatFilter && (
              <div className="c-FilterEnhanced-select-field">
                <input
                  className="c-FilterEnhanced-select-input"
                  type="checkbox"
                  name="filter-enhanced"
                  id={`format_${uid}`}
                />
                <label
                  className="c-FilterEnhanced-select-label"
                  htmlFor={`format_${uid}`}
                >
                  <DfbIcon
                    icon_type="add"
                    add_class="c-FilterEnhanced-select-icon c-FilterEnhanced-select-icon--add"
                  />
                  <DfbIcon
                    icon_type="remove"
                    add_class="c-FilterEnhanced-select-icon c-FilterEnhanced-select-icon--remove"
                  />
                  <DfbIcon
                    icon_type="dropdown-down"
                    add_class="c-FilterEnhanced-select-icon c-FilterEnhanced-select-icon--down"
                  />
                  <DfbIcon
                    icon_type="dropdown-up"
                    add_class="c-FilterEnhanced-select-icon c-FilterEnhanced-select-icon--up"
                  />
                  {text.format}
                </label>
                <div className="c-FilterEnhanced-dropdown-menu">
                  {availableFilterOptions.formats.map((item) => (
                    <div
                      key={item.uid}
                      className="c-FilterEnhanced-dropdown-item"
                    >
                      <input
                        className="c-FilterEnhanced-dropdown-input"
                        type="checkbox"
                        name="format"
                        value={item.uid}
                        id={`format-${item.uid}_${uid}`}
                        onChange={handleFilter}
                        disabled={item.disabled ? true : undefined}
                      />
                      <div className="c-FilterEnhanced-dropdown-label">
                        <DfbIcon
                          icon_type="check"
                          add_class="c-FilterEnhanced-dropdown-icon"
                        />
                        {item.title}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {showCategoryFilter && (
              <div className="c-FilterEnhanced-select-field">
                <input
                  className="c-FilterEnhanced-select-input"
                  type="checkbox"
                  name="filter-enhanced"
                  id={`category_${uid}`}
                />
                <label
                  className="c-FilterEnhanced-select-label"
                  htmlFor={`category_${uid}`}
                >
                  <DfbIcon
                    icon_type="add"
                    add_class="c-FilterEnhanced-select-icon c-FilterEnhanced-select-icon--add"
                  />
                  <DfbIcon
                    icon_type="remove"
                    add_class="c-FilterEnhanced-select-icon c-FilterEnhanced-select-icon--remove"
                  />
                  <DfbIcon
                    icon_type="dropdown-down"
                    add_class="c-FilterEnhanced-select-icon c-FilterEnhanced-select-icon--down"
                  />
                  <DfbIcon
                    icon_type="dropdown-up"
                    add_class="c-FilterEnhanced-select-icon c-FilterEnhanced-select-icon--up"
                  />
                  {text.category}
                </label>
                <div className="c-FilterEnhanced-dropdown-menu">
                  {availableFilterOptions.root_categories.map((item) => (
                    <div
                      key={item.uid}
                      className="c-FilterEnhanced-dropdown-item"
                    >
                      <input
                        className="c-FilterEnhanced-dropdown-input"
                        type="checkbox"
                        name="category"
                        value={item.uid}
                        id={`category-${item.uid}_${uid}`}
                        onChange={handleFilter}
                        disabled={item.disabled ? true : undefined}
                      />
                      <div className="c-FilterEnhanced-dropdown-label">
                        <DfbIcon
                          icon_type="check"
                          add_class="c-FilterEnhanced-dropdown-icon"
                        />
                        {item.disabled}
                        {item.title}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="c-FilterEnhanced-footer">
            <div
              className="c-FilterEnhanced-results-button"
              role="button"
              tabIndex="0"
            >
              {replacePlaceholder(text.show_results, textContext)}
            </div>
          </div>
        </div>
      </div>
      <div className="c-FilterEnhanced-tags">
        {showFormatFilter &&
          availableFilterOptions.formats.map((item) => (
            <label
              key={item.uid}
              className="c-FilterEnhanced-tag c-FilterEnhanced-tag--primary"
              htmlFor={`format-${item.uid}_${uid}`}
              style={{ display: 'none' }}
            >
              <DfbIcon
                icon_type="close"
                add_class="c-FilterEnhanced-tag-icon"
              />
              {item.title}
            </label>
          ))}
        {showCategoryFilter &&
          availableFilterOptions.root_categories.map((item) => (
            <label
              key={item.uid}
              className="c-FilterEnhanced-tag c-FilterEnhanced-tag--secondary"
              htmlFor={`category-${item.uid}_${uid}`}
              style={{ display: 'none' }}
            >
              <DfbIcon
                icon_type="close"
                add_class="c-FilterEnhanced-tag-icon"
              />
              {item.title}
            </label>
          ))}
      </div>
      {totalCount === 0 && <p className="dfb-Paragraph">{text.no_results}</p>}
    </div>
  )
}

export default CFilterEnhanced
